var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunFactIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.174,
    height: 21.728,
    viewBox: "0 0 26.174 21.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8303",
    "data-name": "Group 8303",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8328",
    "data-name": "Group 8328",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4658",
    "data-name": "Path 4658",
    d: "M24.29,22.964h0c-1.847,1.313-3.862.149-5.636-.874-1.191-.684-2.214-1.277-3.1-1.046a3.9,3.9,0,0,0-2.39,1.811c-.036.063-.067.127-.1.19,0-.041-.041-.081-.063-.122a3.9,3.9,0,0,0-2.39-1.811c-.878-.231-1.906.358-3.1,1.046-1.775,1.023-3.79,2.187-5.637.874C.889,22.326.522,22.19.2,22.434a.53.53,0,0,0-.149.629,4.154,4.154,0,0,0,.77,1.019.49.49,0,0,0,0,.081v8.6a.453.453,0,0,0,.905,0V24.952c1.843,1.684,4.794,3.78,6.845,3.78h.181c1.5-.1,3.482-.421,4.355-2.042.905,1.557,2.839,1.879,4.314,1.974H17.6c3.065,0,8.149-4.686,8.525-5.668a.53.53,0,0,0-.149-.643c-.313-.231-.711-.1-1.685.611M12.519,25.68c-.353,1.331-1.534,1.992-3.839,2.137-1.766.122-4.636-1.978-6.37-3.536,2.023.747,4.074-.453,5.645-1.358.973-.561,1.9-1.091,2.413-.955a3.023,3.023,0,0,1,2.15,3.694Zm4.948,2.069c-2.3-.145-3.49-.806-3.839-2.137a3.024,3.024,0,0,1,2.136-3.705l.028-.007a.713.713,0,0,1,.181,0,5.976,5.976,0,0,1,2.227.978c1.562.905,3.622,2.087,5.646,1.358-1.752,1.539-4.618,3.626-6.366,3.518Z",
    transform: "translate(0 -11.49)",
    fill: "#5066e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4659",
    "data-name": "Path 4659",
    d: "M4.256,3.62a.453.453,0,0,0,0,.905h.905a4.528,4.528,0,1,0,9.054.127,1.005,1.005,0,0,1,1.811,0,4.527,4.527,0,0,0,9.032.326h.928a.453.453,0,1,0,0-.905h-.928a4.527,4.527,0,0,0-8.9-.6,1.914,1.914,0,0,0-2.069,0,4.527,4.527,0,0,0-8.837.149ZM20.553.9a3.622,3.622,0,1,1-3.622,3.622A3.622,3.622,0,0,1,20.553.9M9.688.9A3.622,3.622,0,1,1,6.067,4.525,3.622,3.622,0,0,1,9.688.9",
    transform: "translate(-2.081 0)",
    fill: "#5066e7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunFactIcon);
export default __webpack_public_path__ + "static/media/fun-fact-icon.a05f0d292f338c4c5dee962bd29c20d4.svg";
export { ForwardRef as ReactComponent };